import { render, staticRenderFns } from "./BuyerDashboardCampaigns.vue?vue&type=template&id=c4caeb92&scoped=true"
import script from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"
export * from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4caeb92",
  null
  
)

export default component.exports